import { useCallback, useEffect, useRef, useState } from 'react';
import { useEmailLogService } from '../../services/emailLogService';

export const EMAIL_LOG_PAGE_SIZE = 20;

/** One page of the email log for the current recipient search and column sort. */
export function useEmailLog(onLoadError) {
    const { getEmailLog } = useEmailLogService();
    const [recipient, setRecipient] = useState('');
    const [page, setPage] = useState(1);
    // { field, order: 'ASC' | 'DESC' }, or null for the API's newest-first default
    const [sort, setSort] = useState(null);
    const [data, setData] = useState({ items: [], total: 0 });
    const [loading, setLoading] = useState(false);
    const latestRequest = useRef(0);

    const load = useCallback(async () => {
        // a response that lands after a newer request is for a search or page the admin already left
        const requestId = ++latestRequest.current;
        const isLatest = () => requestId === latestRequest.current;
        setLoading(true);
        try {
            const result = await getEmailLog({
                recipient: recipient || undefined,
                page,
                pageSize: EMAIL_LOG_PAGE_SIZE,
                ...(sort && { sortField: sort.field, sortOrder: sort.order }),
            });
            if (isLatest()) setData(result);
        } catch (error) {
            if (isLatest()) onLoadError();
        } finally {
            if (isLatest()) setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recipient, page, sort]);

    useEffect(() => {
        load();
    }, [load]);

    const search = value => {
        setRecipient(value.trim());
        setPage(1);
    };

    const sortBy = value => {
        setSort(value);
        setPage(1);
    };

    return { data, loading, page, setPage, search, sort, sortBy };
}
